import { useEffect, useState } from "react";
import { useAppSelector } from "redux/hooks";
import { selectReviewerCaseStats } from "redux/slices/clientLens";
import theme from "theme";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

interface CaseStatsProps {
  height?: Highcharts.ChartOptions["height"];
  center?: Highcharts.PlotPieOptions["center"];
}

const CaseStats = (props: CaseStatsProps) => {
  const { height, center } = props;
  const caseStats = useAppSelector(selectReviewerCaseStats);
  const [options, setOptions] = useState<Highcharts.Options>({
    chart: {
      plotBackgroundColor: undefined,
      plotBorderWidth: 0,
      plotShadow: false,
      backgroundColor: "transparent",
      height: height !== null && height !== undefined ? height : 200,
    },
    title: {
      text: "",
      style: {
        fontFamily: "Inter,arial,sans-serif",
        fontWeight: "bold",
        color: theme.palette.grey[900],
      },
      align: "center",
      verticalAlign: "middle",
      y: 40,
    },
    plotOptions: {
      pie: {
        dataLabels: {
          enabled: false,
        },
        startAngle: -90,
        endAngle: 90,
        center: center || ["50%", 100],
        size: 250,
      },
    },
    tooltip: {
      pointFormat: "{series.name}: <b>{point.y}</b>",
    },
    credits: {
      enabled: false,
    },
    series: [],
  });

  useEffect(() => {
    const dataLabels = {
      style: {
        fontFamily: "Inter,arial,sans-serif",
        color: "#000",
        textOutline: "none",
      },
    };
    const data: Highcharts.PointOptionsObject[] = [
      {
        name: "Complete",
        y: caseStats.completeCount,
        color: theme.palette.patternSecondary.main,
        dataLabels,
      },
      {
        name: "Pending",
        y: caseStats.newCount + caseStats.newDocumentsCount,
        color: theme.palette.primary.main,
        dataLabels,
      },
      {
        name: "No Documents",
        y: caseStats.noDocumentsCount,
        color: theme.palette.default.main,
        dataLabels,
      },
    ];
    const dataToShow = data.filter((d) => d.y);

    setOptions({
      series: [
        {
          type: "pie",
          name: "Cases",
          innerSize: "78%",
          data: dataToShow,
        },
      ],
      title: {
        text: `${caseStats.activeCount.toLocaleString()}`,
      },
    });
  }, [caseStats]);

  return <HighchartsReact highcharts={Highcharts} options={options} />;
};

export default CaseStats;
